import {calculateChoicePoints, countAnswer, numberOnly, shuffleArray} from '../utils.js';
import text from '../constants.js';
import renderComponent from './renderComponent.js';
import { createElement } from '../utils.js';
import renderIcon from './renderIcon.js';

export default function renderChoices (componentElement, props, data, obj) {
    const answerElement = renderComponent(componentElement, props, data, obj);        
    if(obj.mode <= 2){
        if(!(data.choices ?? []).length) {
            data.choices = [text.CHOICE_TEXT + ' 1'];
        }    
    }

    const addChoice = (props, data, answerElement) => {
        const choiceRow = createElement('div', {
            className: 'x-choice-row'
        });
        const type = props.type == 'select' ? 'radio' : props.type;
        const choiceEls = answerElement.querySelectorAll('.x-choice-text');
        const n_choices = choiceEls.length + 1;
        const texts = Array.from(choiceEls).map(x => x.innerText);
        let choice_string = data.choice_text ?? text.CHOICE_TEXT + ' ' + (n_choices);

        const input = createElement('input', {
            type: type,
            name: data.id,
            className: 'x-choice-answer',
            value: choice_string,
            on_click: e => countAnswer(e, obj)
        });
        
        if(data.isChecked) {
            input.checked = true;
        }
        choiceRow.appendChild(input);
        if(texts.includes(choice_string)) choice_string += '.A';
        const choice_text = createElement('span', {
            innerText: choice_string,
            className: obj.mode == 1 ? 'x-choice-text x-preview' : 'x-choice-text'
        });
        if (obj.mode==1){
            choice_text.contentEditable = true;
            choice_text.addEventListener('blur', (e) => {
                e.target.previousElementSibling.value = e.target.innerText;
            })
        } 
        choiceRow.appendChild(choice_text);

        if (obj.mode==1) {
            const choice_point = createElement('span', {
                className: 'x-choice-point',
                innerText: data.choice_point ?? 0,
                contentEditable: true,
                title: text.CHOICE_POINT,
                on_keydown: numberOnly,
                on_blur: (e) =>{
                    const point = parseInt(e.target.innerText); 
                    if(point > 0){
                        const inputEl = e.target.parentNode.querySelector('.x-choice-answer');
                        if(inputEl) inputEl.dataset.point = point;    
                    }
                    const points = calculateChoicePoints(answerElement);
                    if(points.total_choice_points) {
                        const pointEl = answerElement.parentNode.querySelector('.x-point');
                        pointEl.innerText = props.type == 'checkbox' ? points.total_choice_points : points.max_choice_points;                    
                    }
                }
            })
            choiceRow.appendChild(choice_point);

            const deleteBtn = createElement('button', {
                className: 'x-choice-delete',
                title: text.DELETE_CHOICE,
                innerHTML: renderIcon('remove', { width:'12px', style:'fill:gray;' }),
                on_click: () => {
                    const targetRow = deleteBtn.closest('.x-choice-row');
                    if (targetRow.parentNode.children.length > 1) targetRow.remove();
                }
            });
            choiceRow.appendChild(deleteBtn);
        }
        return choiceRow;
    };

    switch (obj.mode) {
        case 1:
            data.choices.forEach((x, i) => {
                const isChecked = obj.mode==1 ? (data.correct_answer || []).includes(x) : (data.answer || []).includes(x);            
                const currentData = {choice_text: x, isChecked: isChecked, choice_point: data.choice_points ? (data.choice_points[i] ?? 0) : 0, ...data};
                const optionRow = addChoice(props, currentData, answerElement);
                answerElement.appendChild(optionRow);
            })    
            const addChoiceBtn = createElement('div', {
                innerHTML: `[+] ${text.ADD_CHOICE}`,
                className: 'x-add-choice',
                on_click: () => {
                    answerElement.appendChild(addChoice(props, data, answerElement));
                }
            });
            answerElement.after(addChoiceBtn);
            break;
        case 2:
            let select = false;
            if(props.type == 'select') {
                select = createElement('select', {
                    className: 'x-answer-select',
                    name: data.id,
                    on_change: e => countAnswer(e, obj)
                })                
                select.appendChild(createElement('option', {
                    value: '',
                    innerText: text.NONE
                }));
                answerElement.appendChild(select);
            }    

            data.choices = shuffleArray(data.choices);
            data.choices.forEach(x => {
                const isChecked = (data.answer || []).includes(x);            
                if(props.type == 'select') {
                    const optionItem = createElement('option', {
                        value: x,
                        innerText: x
                    })
                    if(isChecked) optionItem.selected = true;
                    select.appendChild(optionItem);
                } else {
                    const currentData = {choice_text: x, isChecked: isChecked, ...data};
                    const optionRow = addChoice(props, currentData, answerElement);
                    answerElement.appendChild(optionRow);    
                }
            })                            
            break;                
        default:
            answerElement.classList.add('x-view');
            answerElement.innerHTML = `${(data.answer ?? []).join(', ') || ''}`;
            break;
    }
}